import React, { useContext, useEffect, useState } from 'react';
import { useForm, Controller, get } from 'react-hook-form';
import {TextField,  FormControl,  Select,  MenuItem,  Button,   Card,  Typography,  Grid,  Box,  InputLabel,  FormGroup,  FormControlLabel,  Checkbox,  FormHelperText,  ListItemText,  OutlinedInput,  Autocomplete,  Paper,  Chip,  Divider,  RadioGroup,  Radio,  TableContainer,  Table,  TableHead,  TableRow,  TableCell,  TableBody,  IconButton, CircularProgress,} from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { DesktopDatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import BookingResult from '../BookingResult';
import { BookingService } from '../Service';
import { CustomerService } from '../../Customer/Service';
import ServiceArea from '../ServiceAreaData.json'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DeleteIcon from '@mui/icons-material/Delete';
import Loading from '../../../components/Loader/Loading';
import { StepperContext } from '../BookingForm';
import Time24to12 from '../../../utils/Time24to12';
import { BookingDataContext, StepperDataContext } from './UpdateBooking';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


export default function BookingReview() {
  const {bookingInitiationData,setBookingInitiationData,dateTimeSlot,setDateTimeSlot,chargeDetails,chargeList,finalBookingCalculation,setFinalBookingCalculation,expertDetails} = useContext(BookingDataContext);
  const {activeStep, setActiveStep,completed, setCompleted,handleNext,handleBack,handleComplete,handleReset,bookingResponseDetails, setBookingResponseDetails} = useContext(StepperDataContext);  

  const getFullAddress = () => {
    const addressParts = [
      bookingInitiationData.houseFlatBlockNo,
      bookingInitiationData.apartmentRoadArea,
      // bookingInitiationData.address,
      bookingInitiationData.landmark,
      bookingInitiationData.city,
      bookingInitiationData.state,
      bookingInitiationData.pincode
    ];
  
    // Filter out empty or undefined parts and join with a comma
    return addressParts
      .filter(part => part && part.trim() !== '')
      .join(', ');
  };
  
  const proceedForPayment=(data)=>{
    handleComplete();
    handleNext();
  }

  const modifyTime = (time) => {
    const timeJson = JSON.parse(time);
    return `${dayjs(timeJson.startTime, 'HH:mm:ss').format('h:mm A')} - ${dayjs(timeJson.endTime, 'HH:mm:ss').format('h:mm A')}`
    // return `${Time24to12(timeJson.startTime)} - ${Time24to12(timeJson.endTime)}`;
  };
  // let visitingCharge = 50;
  const [useCoins, setUseCoins] = useState(false);
  const [coinDetails, setCoinDetails] = useState({
    coinValue: 0,
    // coinAmount: 20,
    totalAvailableCoins: 0,
  });

  useEffect(() => {
    const fetchCoinDetails = async () => {
      const subTotal = bookingInitiationData?.services.reduce((acc, service) => acc + service.price * service.quantity, 0);
      try {
        const coinDetailsResponse = await BookingService.getCoinDetails({
          customerId: bookingInitiationData?.customer?.id,
          subTotal: subTotal,
        });
        console.log("coin details Response:",coinDetailsResponse);
        if(coinDetailsResponse.success===1){
          setCoinDetails({
            coinValue: coinDetailsResponse.data?.allotedCoin,
            // coinAmount: coinDetailsResponse.data?.coinProgramData?,
            totalAvailableCoins: bookingInitiationData?.customer?.totalCoin
          })
        }
      } catch (error) {
        console.log("Error in fetching coin details:",error);
        setCoinDetails({
          coinValue: 0,
          // coinAmount: 20,
          totalAvailableCoins: 0,
        })
      }
    }
    fetchCoinDetails();
  },[])

  const handleCoinsChange = (e) => {
    if (e.target.checked) {

      setUseCoins(true);
      console.log("coin details:",coinDetails);
    } else {
      setUseCoins(false);
      console.log("coin details:",coinDetails);
    }
  }

  const calculateTotal = () => {
    let subTotal = 0;
    let visitingCharge = 0;
    let total = 0;
    let coinUsed = 0;
    subTotal = bookingInitiationData?.services.reduce((acc, service) => acc + service.price * service.quantity, 0);
    visitingCharge = parseFloat(subTotal).toFixed(2)>parseFloat(chargeDetails?.waiveVisitCharge)? 0: parseFloat(chargeDetails?.vistingCharge);
    coinUsed = useCoins ? coinDetails.coinValue : 0;
    total = subTotal + visitingCharge - coinUsed;
    // total = parseFloat(subTotal).toFixed(2)>parseFloat(chargeDetails?.waiveVisitCharge)? parseFloat(subTotal).toFixed(2):parseFloat(subTotal+visitingCharge).toFixed(2);
    setFinalBookingCalculation(pre=>{ 
      return {...pre,subTotal:subTotal,visitingCharge:visitingCharge,total:total,coinValue:coinUsed}
    })
  }
  useEffect(()=>{
    calculateTotal();
  },[useCoins])
  return (
    <Box sx={{ overflow: "auto", backgroundColor: "#fff" ,padding:{xs:'2%',md:'1% 3%'}}}>
        <Grid container spacing={2} >
          <Grid item xs={12} sx={{margin:'auto'}}>

            <Grid item xs={12} sx={{mb:'1%'}}>
              <Box>
                <Typography sx={{fontWeight:'600',color:'#494949'}}>Customer Details</Typography>
                <Card sx={{p:'1%',bgcolor:'#dadada4d'}}>
                  <Grid container spacing={1}>
                    <Grid item xs={5}>
                      <Box>
                        <Typography sx={{fontWeight:500,color:'#3E3E3E'}} variant='body1'>Name <Box component={'span'} sx={{fontWeight:600,color:'#6E6E6E',fontSize:'0.875rem'}}>: {bookingInitiationData?.customer?.profile?.firstName||''} {bookingInitiationData?.customer?.profile?.middleName||''} {bookingInitiationData?.customer?.profile?.lastName||''}</Box></Typography>
                        <Typography sx={{fontWeight:500,color:'#3E3E3E'}} variant='body1'>Contact <Box component={'span'} sx={{fontWeight:600}}></Box>: {bookingInitiationData?.customer?.mobileNumber||''}</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography sx={{fontWeight:500,color:'#3E3E3E'}} variant='body1'>Address <Box component={'span'} sx={{fontWeight:600,color:'#6E6E6E',fontSize:'0.875rem'}}>: {bookingInitiationData.addressMode =='select_address'? bookingInitiationData?.address : getFullAddress()}</Box></Typography>
                      <Typography sx={{fontWeight:500,color:'#3E3E3E'}} variant='body1'>Landmark <Box component={'span'} sx={{fontWeight:600,color:'#6E6E6E',fontSize:'0.875rem'}}>: {bookingInitiationData?.landmark||''}</Box></Typography>
                    </Grid>
                  </Grid>
                </Card>
              </Box>
            </Grid>
            <Grid item xs={12} sx={{mb:'1%'}}>
              <Box>
                <Typography sx={{fontWeight:'600',color:'#494949'}}>Service Expert</Typography>
                <Card sx={{p:'1%',bgcolor:'#dadada4d'}}>
                  <Grid container spacing={1}>
                    <Grid item xs={5}>
                      <Box>
                        <Typography sx={{fontWeight:500,color:'#3E3E3E'}} variant='body1'>Name <Box component={'span'} sx={{fontWeight:600,color:'#6E6E6E',fontSize:'0.875rem'}}>: {expertDetails.firstName||''} {expertDetails.middleName||''} {expertDetails.lastName||''}</Box></Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography sx={{fontWeight:500,color:'#3E3E3E'}} variant='body1'>Contact <Box component={'span'} sx={{fontWeight:600,color:'#6E6E6E',fontSize:'0.875rem'}}>: {expertDetails.mobileNumber||''}</Box></Typography>
                    </Grid>
                  </Grid>
                </Card>
              </Box>
            </Grid>
            <Grid item xs={12} sx={{mb:'1%'}}>
              <Box>
                <Typography sx={{fontWeight:'600',color:'#494949'}}>Schedule Details</Typography>
                <Card sx={{p:'1%',bgcolor:'#dadada4d'}}>
                  <Grid container spacing={1}>
                    <Grid item xs={5}>
                      <Box>
                        <Typography sx={{fontWeight:500,color:'#3E3E3E'}} variant='body1'>Date <Box component={'span'} sx={{fontWeight:600,color:'#6E6E6E',fontSize:'0.875rem'}}>: {dateTimeSlot?.serviceDate||''}</Box></Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography sx={{fontWeight:500,color:'#3E3E3E'}} variant='body1'>Slot Timing <Box component={'span'} sx={{fontWeight:600,color:'#6E6E6E',fontSize:'0.875rem'}}>: {modifyTime(dateTimeSlot?.timeSlot)||''}</Box></Typography>
                    </Grid>
                  </Grid>
                </Card>
              </Box>
            </Grid>
            <Grid item xs={12} sx={{mb:'1%'}}>
              <Box>
                <Typography sx={{fontWeight:'600',color:'#494949'}}>Service Details</Typography>
                <Card sx={{bgcolor:'#dadada4d'}}>
                  <Grid container>
                    <Grid item xs={9}>
                      {/* <Box sx={{p:'2%',display:'flex',justifyContent:'space-between',borderBottom:'1px solid #BEC2C2'}}>
                        <Typography sx={{fontWeight:500,color:'#3E3E3E'}} variant='body1'>Category <Box component={'span'} sx={{fontWeight:600}}>: Men’s Kids’ Salon</Box></Typography>
                        <Typography sx={{fontWeight:500,color:'#3E3E3E'}} variant='body1'>Sub-Category <Box component={'span'} sx={{fontWeight:600}}>: Haircut & Beard Styling</Box></Typography>
                      </Box> */}
                      <Box>
                        <TableContainer>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell sx={{fontWeight:600,color:'#6E6E6E',p:'1%'}} width="40%" >Service</TableCell>                                
                                <TableCell sx={{fontWeight:600,color:'#6E6E6E',p:'1%'}} width="15%" >Quantity</TableCell>
                                <TableCell sx={{fontWeight:600,color:'#6E6E6E',p:'1%'}} width="15%" >Time</TableCell>
                                <TableCell sx={{fontWeight:600,color:'#6E6E6E',p:'1%'}} width="15%" >Price</TableCell>
                                <TableCell sx={{fontWeight:600,color:'#6E6E6E',p:'1%'}} width="15%" >Total </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {bookingInitiationData?.services.map((service) => (
                                <TableRow key={service?.id} sx={{borderBottom:'none'}}>
                                  <TableCell sx={{ p: '1%' ,color:'#494949',borderBottom:'none'}}>{service?.title}</TableCell>
                                  <TableCell sx={{ p: '1% 3%' ,color:'#494949',borderBottom:'none'}}>{service?.quantity}</TableCell>
                                  <TableCell sx={{ p: '1%' ,color:'#494949',borderBottom:'none'}}>{service?.serviceTime}mins</TableCell>
                                  <TableCell sx={{ p: '1%' ,color:'#494949',borderBottom:'none'}}>{service?.price}</TableCell>
                                  <TableCell sx={{ p: '1%' ,color:'#494949',borderBottom:'none'}}>{parseFloat(service?.price*service?.quantity).toFixed(2)}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </Grid>
                    <Grid item xs={3} sx={{borderLeft:'1px solid #BEC2C2'}}>
                      <Box sx={{p:'3%',borderBottom:'1px solid #BEC2C2'}}>
                        <Typography sx={{fontWeight:600}}>Payment Summary</Typography>
                      </Box>
                      <Box sx={{ }}>
                        <Box sx={{ p: 1 ,display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                          <Typography variant="body2" color="text.secondary">
                            Subtotal
                          </Typography>
                          <Typography variant="body2">
                            {/* sum of all price*quantity */}
                            ₹ {parseFloat(finalBookingCalculation?.subTotal).toFixed(2)}
                            {/* {bookingInitiationData?.services.reduce((acc, service) => acc + service.price * service.quantity, 0).toFixed(2)} */}
                          </Typography>
                        </Box>
                        
                        <Box sx={{px:1 , display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                          <Typography variant="body2" color="text.secondary">
                            Visiting Charges
                          </Typography>
                          <Typography variant="body2">
                            {/* ₹{parseFloat(chargeDetails?.vistingCharge).toFixed(2)} */}
                            ₹ {parseFloat(finalBookingCalculation?.visitingCharge).toFixed(2)}
                            {/* {parseFloat(bookingInitiationData?.services.reduce((acc, service) => acc + (service.price * service.quantity), 0)).toFixed(2)>parseFloat(chargeDetails?.waiveVisitCharge)? parseFloat(0).toFixed(2):parseFloat(chargeDetails?.vistingCharge).toFixed(2)} */}

                          </Typography>
                        </Box>
                        <Box sx={{px:1 , display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                          <Typography variant="body2" color="text.secondary">
                            Coin Used
                          </Typography>
                          <Typography variant="body2">
                            {/* ₹{parseFloat(chargeDetails?.vistingCharge).toFixed(2)} */}
                            ₹  {parseFloat(finalBookingCalculation?.coinValue).toFixed(2)}
                            {/* {parseFloat(bookingInitiationData?.visitingCharge).toFixed(2)} */}
                            {/* {parseFloat(bookingInitiationData?.services.reduce((acc, service) => acc + (service.price * service.quantity), 0)).toFixed(2)>parseFloat(chargeDetails?.waiveVisitCharge)? parseFloat(0).toFixed(2):parseFloat(chargeDetails?.vistingCharge).toFixed(2)} */}

                          </Typography>
                        </Box>
                        
                        <Divider sx={{ my: .5 }} />
                        
                        <Box sx={{p: 1 , display: 'flex', justifyContent: 'space-between' }}>
                          <Typography variant="body1" sx={{ fontWeight: 600,color:'#3e3e3e' }}>
                            Total Amount
                          </Typography>
                          <Typography variant="body1" sx={{ fontWeight: 600,color:'#3e3e3e' }}>
                          {/* ₹{(parseFloat(bookingInitiationData?.services.reduce((acc, service) => acc + service.price * service.quantity, 0)) + parseFloat(chargeList.platformCharges)).toFixed(2)} */}
                          
                          ₹ {parseFloat(finalBookingCalculation?.total).toFixed(2)}
                          {/* {parseFloat(bookingInitiationData?.services.reduce((acc, service) => acc + (service.price * service.quantity), 0)).toFixed(2)>parseFloat(chargeDetails?.waiveVisitCharge)? parseFloat(bookingInitiationData?.services.reduce((acc, service) => acc + (service.price * service.quantity), 0)).toFixed(2):parseFloat(bookingInitiationData?.services.reduce((acc, service) => acc + (service.price * service.quantity), 0)+parseFloat(chargeDetails?.vistingCharge)).toFixed(2)} */}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Card>
              </Box>
            </Grid>
            {bookingInitiationData?.customer?.totalCoin>0 &&
              <Grid item xs={12} sx={{mb:'1%'}}>
              <FormControl sx={{ minWidth: "100%" }} component="fieldset" >
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                onChange={handleCoinsChange}
                            />
                        }
                        label={`Save ₹ ${coinDetails.coinValue} with ${coinDetails.coinValue} Cudel Coins (Balance: ${bookingInitiationData?.customer?.totalCoin})`}
                    />
                </FormGroup>
              </FormControl>
              </Grid>
            }
            
            {/* submit button section */}
            <Grid container>    
              <Grid item xs={12} sx={{my:'2%'}}>
                <Box textAlign={'center'}>
                  <Button onClick={()=>proceedForPayment()} variant="contained" color="primary">
                    {/* confirm Booking */}
                    Proceed For Payment
                  </Button>
                  <Box sx={{ flexGrow: 1 }}></Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
    </Box >
  );
}
